import React from 'react'

function Footer() {
    return (
        <div>
            <div id='footer' className='fix-bottom'>
                <p className='text-center h5 text-muted footer'>
                    Made with &#10084; by Nikunj Viradiya
                </p>
            </div>
        </div>
    )
}

export default Footer
